import cache from './cache'
import games from './games'

const customReducers = {
  cache,
  games,
}

export default customReducers
